import { Provider } from '../store/store'
import Routes from './Routes';
import ScaleContainer from './ScaleContainer'
import Mockup from './Mockup'
import Nav from './Nav'
import { HashRouter as Router } from "react-router-dom";
import SalesDataLoader from './SalesDataLoader';


function App() {
	return (
		<div className="App">
			<Provider>
				<ScaleContainer>
					<SalesDataLoader>
						<Router>
							<Mockup />
							<Nav />
							<Routes />
						</Router>
					</SalesDataLoader>
				</ScaleContainer>
			</Provider>
		</div>
	);
}

export default App;
